import { Instagram, Youtube, Twitter, Facebook, Music2, Globe } from "lucide-react";

const norm = (v, base) => {
  if (!v) return null;
  if (v.startsWith("http")) return v;
  const handle = v.replace(/^@/, "");
  return base ? `${base}${handle}` : `https://${v}`;
};

export default function SocialLinks({ item, className = "" }) {
  const links = [
    { key: "instagram", Icon: Instagram, href: norm(item.instagram, "https://instagram.com/"), label: "Instagram" },
    { key: "tiktok", Icon: Music2, href: norm(item.tiktok, "https://tiktok.com/@"), label: "TikTok" },
    { key: "youtube", Icon: Youtube, href: norm(item.youtube, "https://youtube.com/"), label: "YouTube" },
    { key: "twitter", Icon: Twitter, href: norm(item.twitter, "https://x.com/"), label: "X" },
    { key: "facebook", Icon: Facebook, href: norm(item.facebook, "https://facebook.com/"), label: "Facebook" },
    { key: "website", Icon: Globe, href: norm(item.website, null), label: "Website" },
  ].filter((l) => l.href);

  if (links.length === 0) return null;

  return (
    <div className={`flex flex-wrap items-center gap-2.5 ${className}`} data-testid="social-links">
      {links.map(({ key, Icon, href, label }) => (
        <a
          key={key}
          href={href}
          target="_blank"
          rel="noreferrer"
          aria-label={label}
          data-testid={`social-${key}`}
          className="w-10 h-10 flex items-center justify-center border border-sand-300 text-sand-900 hover:bg-sand-900 hover:text-sand-50 hover:border-sand-900 transition-colors"
        >
          <Icon size={16} />
        </a>
      ))}
    </div>
  );
}
